import { NativeInvoiceLineRow } from "./nativeInvoiceFormTypes";

export const FROM_ENTITY_LOCKED_AFTER_CREATE_TOOLTIP =
    "The sending business can't be changed after the invoice is created";

export const FROM_ENTITY_LOCKED_CATALOG_ITEMS_TOOLTIP =
    "The sending entity can't be changed because this invoice has catalog items that belong to the selected entity";

export function invoiceHasEntityScopedCatalogItems(
    lines: ReadonlyArray<Pick<NativeInvoiceLineRow, "catalogItemId">>,
): boolean {
    return lines.some((line) => line.catalogItemId != null);
}

export function getNativeInvoiceFromEntityLock({
    isExistingInvoice,
    hasBillableExpenses,
    isTemplateBound,
    lines,
}: {
    isExistingInvoice: boolean;
    hasBillableExpenses: boolean;
    // The draft's content is tied to a template's entity: either a template is
    // being edited/duplicated directly, or a template has been applied (or is
    // being applied) to an otherwise-fresh Create Invoice draft. In both cases
    // the template's lines, design and terms belong to that entity, so From
    // must lock. The caller composes both cases into this single flag.
    isTemplateBound: boolean;
    lines: ReadonlyArray<Pick<NativeInvoiceLineRow, "catalogItemId">>;
}): { isLocked: boolean; tooltip: string | undefined } {
    if (isExistingInvoice || hasBillableExpenses || isTemplateBound) {
        return {
            isLocked: true,
            tooltip: FROM_ENTITY_LOCKED_AFTER_CREATE_TOOLTIP,
        };
    }
    if (invoiceHasEntityScopedCatalogItems(lines)) {
        return {
            isLocked: true,
            tooltip: FROM_ENTITY_LOCKED_CATALOG_ITEMS_TOOLTIP,
        };
    }
    return { isLocked: false, tooltip: undefined };
}
